export default "__VITE_ASSET__acaf1ec6__"